var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestionView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C6.03571 1 2.54286 3.16378 1.06429 6.51667L1 6.65313L1.06429 6.78958C2.54286 10.1425 6.03571 12.3063 10 12.3063C13.9643 12.3063 17.4571 10.1425 18.9357 6.78958L19 6.65313L18.9357 6.51667C17.4571 3.16378 13.9643 1 10 1ZM10 11.5265C6.44286 11.5265 3.31429 9.61614 1.94286 6.65313C3.31429 3.69011 6.44286 1.77974 10 1.77974C13.5571 1.77974 16.6857 3.69011 18.0571 6.65313C16.6857 9.61614 13.5571 11.5265 10 11.5265Z",
    fill: "#00AEEF",
    stroke: "#00AEEF",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.865 3.25C8.07596 3.25 6.625 4.70096 6.625 6.49C6.625 8.27904 8.07596 9.73 9.865 9.73C11.654 9.73 13.105 8.27904 13.105 6.49C13.105 4.70096 11.654 3.25 9.865 3.25ZM9.865 9.16652C8.38587 9.16652 7.18848 7.96913 7.18848 6.49C7.18848 5.01087 8.38587 3.81348 9.865 3.81348C11.3441 3.81348 12.5415 5.01087 12.5415 6.49C12.5415 7.96913 11.3441 9.16652 9.865 9.16652Z",
    fill: "#00AEEF",
    stroke: "#00AEEF",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionView);
export default __webpack_public_path__ + "static/media/icon_questionView.9292a4b3259ed2174f97402923598306.svg";
export { ForwardRef as ReactComponent };